import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkflowIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 20,
	viewBox: "0 0 19 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13 16.5H12.88C11.8719 16.5 11.3679 16.5 10.9828 16.2548C10.6441 16.039 10.3688 15.6948 10.1962 15.2715C10 14.7902 10 14.1601 10 12.9V8.1C10 6.83988 10 6.20982 10.1962 5.72852C10.3688 5.30516 10.6441 4.96095 10.9828 4.74524C11.3679 4.5 11.8719 4.5 12.88 4.5",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.0857 14.5H14.9143C14.5943 14.5 14.4342 14.5 14.312 14.5623C14.2045 14.6171 14.1171 14.7045 14.0623 14.812C14 14.9342 14 15.0943 14 15.4143V17.5857C14 17.9057 14 18.0658 14.0623 18.188C14.1171 18.2955 14.2045 18.3829 14.312 18.4377C14.4342 18.5 14.5943 18.5 14.9143 18.5H17.0857C17.4057 18.5 17.5658 18.5 17.688 18.4377C17.7955 18.3829 17.8829 18.2955 17.9377 18.188C18 18.0658 18 17.9057 18 17.5857V15.4143C18 15.0943 18 14.9342 17.9377 14.812C17.8829 14.7045 17.7955 14.6171 17.688 14.5623C17.5658 14.5 17.4057 14.5 17.0857 14.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.0857 2.5H14.9143C14.5943 2.5 14.4342 2.5 14.312 2.56228C14.2045 2.61707 14.1171 2.70448 14.0623 2.81201C14 2.93424 14 3.09426 14 3.41429V5.58571C14 5.90574 14 6.06576 14.0623 6.18799C14.1171 6.29552 14.2045 6.38293 14.312 6.43772C14.4342 6.5 14.5943 6.5 14.9143 6.5H17.0857C17.4057 6.5 17.5658 6.5 17.688 6.43772C17.7955 6.38293 17.8829 6.29552 17.9377 6.18799C18 6.06576 18 5.90574 18 5.58571V3.41429C18 3.09426 18 2.93424 17.9377 2.81201C17.8829 2.70448 17.7955 2.61707 17.688 2.56228C17.5658 2.5 17.4057 2.5 17.0857 2.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.08571 8.5H1.91429C1.59426 8.5 1.43424 8.5 1.31201 8.56228C1.20448 8.61707 1.11707 8.70448 1.06228 8.81201C1 8.93424 1 9.09426 1 9.41429V11.5857C1 11.9057 1 12.0658 1.06228 12.188C1.11707 12.2955 1.20448 12.3829 1.31201 12.4377C1.43424 12.5 1.59426 12.5 1.91429 12.5H4.08571C4.40574 12.5 4.56576 12.5 4.68799 12.4377C4.79552 12.3829 4.88293 12.2955 4.93772 12.188C5 12.0658 5 11.9057 5 11.5857V9.41429C5 9.09426 5 8.93424 4.93772 8.81201C4.88293 8.70448 4.79552 8.61707 4.68799 8.56228C4.56576 8.5 4.40574 8.5 4.08571 8.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 6,
			y1: 10.5,
			x2: 9,
			y2: 10.5,
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
export default SvgWorkflowIcon;
